// Helper/steadFastEntry.js
import myAxios from '../AxiosUrl';
import { toast } from 'react-toastify';

export const steadFastEntryHelper = (
    uid,
    selectedItems,
    setSteadFastLoading,
    setSelectedItems,
    onDone
) => {
    // Validate that orders are selected
    if (!selectedItems || selectedItems.length === 0) {
        toast.warning('Please select at least one order for SteadFast entry');
        return;
    }

    setSteadFastLoading(true);
    myAxios
        .post(`steadfast/${uid}`, selectedItems)
        .then((res) => {
            setSteadFastLoading(false);
            setSelectedItems([]);

            // Sent orders move to Courier Done: reload the list
            if (typeof onDone === 'function') onDone();

            // Handle success message (partly sent = some lines not sent)
            if (res.data && /Not sent:/.test(String(res.data))) {
                toast.warning(String(res.data), { autoClose: 12000 });
            } else if (res.data) {
                toast.success(String(res.data));
            } else {
                toast.success(`Successfully created ${selectedItems.length} SteadFast ${selectedItems.length === 1 ? 'entry' : 'entries'}`);
            }
        })
        .catch((error) => {
            console.error('SteadFast Entry Error:', error);
            setSteadFastLoading(false);

            // Handle error messages
            if (error.response?.data?.message) {
                toast.error(`Failed: ${error.response.data.message}`);
            } else if (error.response?.data) {
                toast.error(`Failed: ${error.response.data}`);
            } else if (error.message) {
                toast.error(`Failed to create SteadFast entry: ${error.message}`);
            } else {
                toast.error('Failed to create SteadFast entry. Please try again.');
            }
        });
};
